import { render, staticRenderFns } from "./ActionDown.vue?vue&type=template&id=1b87ef5e&"
import script from "./ActionDown.vue?vue&type=script&lang=js&"
export * from "./ActionDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports